import { bunja } from 'bunja';
import { atom } from 'jotai';
import { selectAtom } from 'jotai/utils';

import { pnlModeBunja } from '@flipster/features/src/shared/pnl-setting-modal/state';
import { openPositionsBunja } from '@flipster/r230522/original/position';

import { tradeSymbolBunja } from '@web/app/[locale]/(web)/trade/_misc/symbol';

import { yourPositionsBunja } from '../../state';
import { containsFlippablePosition } from './cta-layout';
import { areOpenPositionKeysEqual, toOpenPositionKeys } from './position-identity';

/**
 * 열린 포지션 테이블의 데이터 레이어. 계산은 전부 여기서 하고 UI는 consume만 한다.
 * `openPositionsAtom`은 소켓 tick마다 전체를 재구성하므로, 행 목록 입력을 (symbol, slot) 키로
 * 축소하고 집합·순서가 같으면 이전 배열 identity를 유지해 tick마다 renderRow가 재실행되지 않게 한다.
 */
export const openPositionTableDataBunja = bunja(() => {
  const { symbol } = bunja.use(tradeSymbolBunja);
  const { openPositionsAtom } = bunja.use(openPositionsBunja);
  const { showAllSymbolAtom } = bunja.use(yourPositionsBunja);
  const { pnlModeAtom } = bunja.use(pnlModeBunja);

  const currentPositionsAtom = atom((get) => {
    const openPositions = get(openPositionsAtom);
    return get(showAllSymbolAtom) ? Object.values(openPositions ?? {}).flat() : (openPositions?.[symbol] ?? []);
  });

  // 행 렌더 입력은 {symbol, slot} 키만. 집합·순서 동일 시 이전 배열 identity 유지 → Table 리렌더 차단.
  const positionKeysAtom = selectAtom(
    atom((get) => toOpenPositionKeys(get(currentPositionsAtom))),
    (keys) => keys,
    areOpenPositionKeysEqual,
  );

  const hasNoPositionsAtom = atom((get) => get(positionKeysAtom).length === 0);

  // airdrop 포지션은 flip이 불가하므로, flip 가능한 일반 포지션이 하나도 없으면 헤더의 'Flip position' 라벨을 숨긴다
  const hasFlippablePositionAtom = atom((get) => containsFlippablePosition(get(currentPositionsAtom)));

  const isNetPnlModeAtom = atom((get) => get(pnlModeAtom) === 'netPnl');

  return { positionKeysAtom, hasNoPositionsAtom, hasFlippablePositionAtom, isNetPnlModeAtom };
});
openPositionTableDataBunja.debugLabel = 'openPositionTableDataBunja';
